var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { MetaContainer } from '../elements/meta-container';
import { EntityMetaSection } from './entity-meta-section';
import { CellLabel } from '../elements/cell-label';
import { useLang } from '../hooks/use-lang';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('page-meta-head-layout');
export var PostAsideLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-top: ", ";\n    gap: ", ";\n  "], ["\n    padding-top: ", ";\n    gap: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4))
});
var SectionStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('text-mid'), theme.UNIT(4))
});
var MetaSectionStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(MetaContainer)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Section: styled.section(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Title: styled(CellLabel)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  MetaSection: styled(EntityMetaSection)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), MetaSectionStyles)
};
export var PostAsideLayout = function (props) {
  var _a = useComponentPropsFor('PostAsideLayout', PostAsideLayoutDefaultProps, props),
    className = _a.className,
    children = _a.children,
    _b = _a.metaItems,
    metaItems = _b === void 0 ? [] : _b,
    entity = _a.entity;
  var _c = entity.people,
    people = _c === void 0 ? [] : _c,
    _d = entity.authors,
    authors = _d === void 0 ? [] : _d;
  var hasPeople = !!people.length;
  var hasAuthors = !!authors.length;
  var hasMetaItems = !!metaItems.length;
  var t = useLang();
  // must return null if there is nothing to render, otherwise parent components
  // may render empty divs
  if (!hasPeople && !hasAuthors && !hasMetaItems) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasAuthors && React.createElement(My.Section, null, React.createElement(My.MetaSection, {
    label: "Authors",
    items: authors || []
  })), hasPeople && React.createElement(My.Section, null, React.createElement(My.Title, null, t('People')), React.createElement(My.MetaSection, {
    items: people || []
  })), hasMetaItems && metaItems.map(function (_a) {
    var items = _a.items,
      title = _a.title,
      label = _a.label;
    return React.createElement(My.Section, {
      key: title
    }, React.createElement(My.Title, null, t(title)), React.createElement(My.MetaSection, {
      label: t(label),
      items: items || []
    }));
  }));
};
PostAsideLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;